import { useState, useEffect, useCallback, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput, MultiSelectInput } from '../forms';
import { partnerOfficeActions, PartnerOfficeStore } from '../../../partners/store/offices/partnerOfficeStore';
type OfficeSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    partnerOfficeStore?: PartnerOfficeStore,
    // если partnerId или serviceId не передан, то включаем disable на компонент
    partnerId?: string, // фильтруем офисы по Партнеру
    serviceId?: number, // фильтруем офисы, оказывающие услуги по данным сервисам
    schedulerClassifierRefValueId?: number, // фильтруем офисы, привязанные к региону
    mapFieldToSelectedOptions?: (options: any[], values: unknown) => any[],
    multiSelect?: boolean,
    /** z-index выпадающего списка; имеет смысл только в multiSelect-режиме. */
    dropDowndzIndex?: number,
  };

const OfficeSelector = (props: OfficeSelectorProps) => {
  const {
    partnerOfficeStore,
    partnerId,
    serviceId,
    schedulerClassifierRefValueId,
    multiSelect,
    mapFieldToSelectedOptions,
    ...rest
  } = props;

  const { officesForSelector } = partnerOfficeStore;

  const [loading, setLoading] = useState(false);

  const loadData = useCallback(() => {
    if (partnerId || serviceId) {
      // marker читаем из стора живьём, а не из снапшота рендера: иначе оба эффекта монтирования
      // видят одинаковый пустой marker и отправляют дублирующий запрос
      const { officesForSelectorByRequest } = partnerOfficeStore;
      if ((officesForSelectorByRequest?.partnerId !== partnerId)
         || (officesForSelectorByRequest?.serviceId !== serviceId)
         || (officesForSelectorByRequest?.schedulerClassifierRefValueId !== schedulerClassifierRefValueId)
      ) {
        // Очищаем старые данные синхронно перед запросом, чтобы не было мигания неактуальным списком
        partnerOfficeActions.clearOfficesForSelector();
        setLoading(true);

        partnerOfficeActions.getOfficesForSelector({
          partnerId,
          serviceId,
          schedulerClassifierRefValueId,
          showDeleted: false,
        }).finally(() => setLoading(false));
      }
    }
  }, [schedulerClassifierRefValueId, partnerId, serviceId]);

  useComponentDidMount(() => {
    loadData();
  });

  useEffect(() => {
    loadData();
  }, [partnerId, serviceId, schedulerClassifierRefValueId ]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti 
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ officesForSelector }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          disabled={ rest?.disabled || ((!partnerId) && (!serviceId)) }
          mapFieldToSelectedOptions= { mapFieldToSelectedOptions }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ officesForSelector }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          disabled={ rest?.disabled || ((!partnerId) && (!serviceId)) }
          sort
        />
      )

  );
};

export default inject('partnerOfficeStore')(observer(OfficeSelector));
